import { AppSelectBox } from 'components';
import useSubjectChapters from 'hooks/API/GET/useSubjectChapters';
import { Fragment } from 'react';

function SubjectChaptersDropDown({
  enableAPI,
  value,
  handleChange,
  dependencies = {},
  fieldErrors = {},
}) {
  const { query = '', classID, subjectID } = dependencies;
  const queryParams = `?mode=dropdown${query ? `&${query}` : ``}`;

  const { data, isLoading, isError } = useSubjectChapters({
    enabled: enableAPI,
    queryParams,
    classID,
    subjectID,
  });

  return (
    <AppSelectBox
      labelProps={{ label: 'Select chapters' }}
      selectProps={{
        value,
        onChange: handleChange,
      }}
      fieldErrors={fieldErrors}
    >
      {isLoading ? (
        <option disabled value="">
          Loading...
        </option>
      ) : isError ? (
        <option disabled value="">
          Failed to load list
        </option>
      ) : (
        <Fragment>
          {data?.data?.length > 0 ? (
            <Fragment>
              <option value="">Choose</option>
              {data?.data?.map((option) => {
                return (
                  <option key={option._id} value={option._id}>
                    {option.name}
                  </option>
                );
              })}
            </Fragment>
          ) : (
            <option value="">No options found</option>
          )}
        </Fragment>
      )}
    </AppSelectBox>
  );
}

SubjectChaptersDropDown.defaultProps = {
  handleChange: () => {},
};

export default SubjectChaptersDropDown;
